jQuery(function ($) {

  $(document).on("click", ".question_product, .faq_question, .section3_icons_lp .icons_with_text_item_flex", function () {

    let $this = $(this);
    let $content = $this.next();

    if ($this.hasClass("active")) {
      $this.removeClass("active");
      $content.stop(true, true).slideUp();
    } else {
      $(".question_product, .faq_question, .section3_icons_lp .icons_with_text_item_flex")
        .removeClass("active");

      $(".question_product, .faq_question, .section3_icons_lp .icons_with_text_item_flex")
        .next()
        .stop(true, true)
        .slideUp();

      $this.addClass("active");
      $content.stop(true, true).slideDown();
    }

  });

});




 $(document).on("click", ".custom_button", function (e) {
     var video = jQuery(this).parents('.video_wrapper_custom').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
     jQuery(this).addClass('active');
 }
 });







$(document).on("click", "a[href='#compare']", function (e) {
  e.preventDefault();
  document.querySelector('#compare').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#faq']", function (e) {
  e.preventDefault();
  document.querySelector('#faq').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_page_product').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

function isAtViewportMidline(el) {
  if (!el || !el.getBoundingClientRect) return false;
  if (!$(el).is(':visible')) return false;

  const rect = el.getBoundingClientRect();
  const vw = window.innerWidth || document.documentElement.clientWidth;
  const vh = window.innerHeight || document.documentElement.clientHeight;
  const midY = vh / 2;

  // horizontally on-screen AND the element spans the middle line
  return rect.left < vw && rect.right > 0 && rect.top < midY && rect.bottom > midY;
}

function runCounters($block) {
  $block.addClass('start_count');
  $block.find('.count_js').each(function () {
    const $c = $(this);
    const target = +($c.data('value') || 0);
    $c.prop('Counter', 0).stop(true).animate(
      { Counter: target },
      {
        duration: 2000,
        easing: 'swing',
        step: function (now) { $c.text(Math.ceil(now)); }
      }
    );
  });
}

function checkCountersInView() {
  $('.custom_counter .icons_with_text_flex').each(function () {
    const $block = $(this);
    if ($block.hasClass('start_count')) return;          // only once
    if (isAtViewportMidline(this)) runCounters($block); // trigger when truly visible
  });
}

$(window).on('scroll load', checkCountersInView);




$(document).on("click", ".tab_item_pdp", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tab_item_pdp').removeClass('active');
$(this).addClass('active');
$('.tab_content_pdp').hide();
$('.tab_content_pdp[data_tab="'+data_tab+'"]').show();
});


$(document).on("click", '.ajax_add_cart', function(e) {
 e.preventDefault(); 
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
var id = jQuery(this).attr('variant_id');
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: id
},
  dataType: 'json', 
 success: function (data) { 
    $.get(window.location.pathname, function (res) {
      var $new = $(res).find('#cart_drawer_content');
      $('#cart_drawer_content').replaceWith($new);
         // Update cart count
      const $newCartCount = $(res).find('.cart_count_js');
      const cartCount = parseInt($newCartCount.text().trim(), 10);
      
      if (cartCount > 0) {
        $('.cart_count_js').text(cartCount).show();
      } else {
        $('.cart_count_js').text('').hide();
      }
      $('#cart-drawer').removeClass('is_empty').addClass('open');
      $('.custom_overlay2').addClass('active');
      this_element.removeClass('loading_hk');
    });
 } 
 });
  });



   $(window).scroll(function(){
      if ($(this).scrollTop() > 30) {
         $('body').addClass('remove_transparent');
      } else {
         $('body').removeClass('remove_transparent');
      }
  });


  function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+100;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.timeline_icons .icons_with_text_item').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
    });
});



$(document).on("click", ".trigger_reviews_js_show", function (e) {
$('.review_with_text_landing_page_item.active').last().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
});

$(document).on("click", ".trigger_reviews_js_hide", function (e) {
$('.review_with_text_landing_page_item:nth-child(3)~.review_with_text_landing_page_item').hide().removeClass('active');
});
